import menuIcon from '@/assets/icons/mint.svg';
import missionIcon from '@/assets/icons/mission-icn.svg';

import { routes } from './routes';

type MenuItem = {
  name: string;
  icon: string;
  link: string;
  disabled?: boolean;
};

export type MenuNames = 'mint' | 'missions' | null;
export type MenuRoutes = typeof routes.mint | typeof routes.missions;

export const menu: MenuItem[] = [
  {
    name: 'common.menu.soon',
    icon: menuIcon,
    link: routes.mint,
    disabled: false,
  },
  {
    name: 'wallet.menu.missions',
    icon: missionIcon,
    link: routes.missions,
    disabled: false,
  },
];

export const menuRoutes = [routes.mint, routes.missions];
